import { createContext } from "react";

export interface User {
    id: string;
    email: string;
    name?: string;
    /** Avatar URL (Google's picture, or a blob URL for the worker-hosted copy). */
    picture?: string;
    googleId?: string;
    userRole?: string;
}

export interface UserContextProps {
    user?: User | string;
    token?: string;
    setUser?: (user: User | string) => void;
    setToken?: (token: string) => void;
    logout?: () => void;
    isAuthenticated: boolean;
}

export const UserContext = createContext<UserContextProps>({
    isAuthenticated: false,
});
